import * as React from 'react';
const MastercardIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="metodi pagamento icon"
      viewBox="0 0 46.93 29"
      {...props}
    >
      <path
        d="M22.18 26.29c.11.1.23.19.35.29-2.3 1.53-5.06 2.42-8.03 2.42C6.49 29 0 22.51 0 14.5S6.49 0 14.5 0c2.97 0 5.73.89 8.03 2.42-.12.1-.23.19-.32.29-3.43 2.97-5.4 7.27-5.4 11.79s1.96 8.82 5.37 11.79ZM32.43 0c-2.97 0-5.73.89-8.03 2.42.12.1.23.19.32.29 3.43 2.97 5.4 7.27 5.4 11.79s-1.96 8.81-5.37 11.79c-.11.1-.23.19-.35.29 2.3 1.53 5.06 2.42 8.03 2.42 8.01 0 14.5-6.49 14.5-14.5S40.44 0 32.43 0Zm-8.96 3.11c-.19.15-.37.29-.55.45-3.06 2.66-4.99 6.57-4.99 10.94s1.93 8.28 4.99 10.94c.18.16.36.31.55.45.19-.14.37-.3.55-.45 3.06-2.66 4.99-6.57 4.99-10.94s-1.93-8.28-4.99-10.94c-.18-.16-.36-.31-.55-.45Z"
        style={{
          fill,
        }}
      />
    </svg>
  );
};
export default MastercardIcon;
